/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AssetUploadUrlDto } from '../models/asset-upload-url-dto';
import { JobAnswersDto } from '../models/job-answers-dto';
import { workerControllerClaim } from '../fn/worker/worker-controller-claim';
import { WorkerControllerClaim$Params } from '../fn/worker/worker-controller-claim';
import { workerControllerCompleteJob } from '../fn/worker/worker-controller-complete-job';
import { WorkerControllerCompleteJob$Params } from '../fn/worker/worker-controller-complete-job';
import { workerControllerFailJob } from '../fn/worker/worker-controller-fail-job';
import { WorkerControllerFailJob$Params } from '../fn/worker/worker-controller-fail-job';
import { workerControllerGetAnswers } from '../fn/worker/worker-controller-get-answers';
import { WorkerControllerGetAnswers$Params } from '../fn/worker/worker-controller-get-answers';
import { workerControllerGetAssetUploadUrl } from '../fn/worker/worker-controller-get-asset-upload-url';
import { WorkerControllerGetAssetUploadUrl$Params } from '../fn/worker/worker-controller-get-asset-upload-url';
import { workerControllerGetVideoUrl } from '../fn/worker/worker-controller-get-video-url';
import { WorkerControllerGetVideoUrl$Params } from '../fn/worker/worker-controller-get-video-url';
import { workerControllerHeartbeat } from '../fn/worker/worker-controller-heartbeat';
import { WorkerControllerHeartbeat$Params } from '../fn/worker/worker-controller-heartbeat';
import { workerControllerPublishEvents } from '../fn/worker/worker-controller-publish-events';
import { WorkerControllerPublishEvents$Params } from '../fn/worker/worker-controller-publish-events';
import { workerControllerPublishQuestions } from '../fn/worker/worker-controller-publish-questions';
import { WorkerControllerPublishQuestions$Params } from '../fn/worker/worker-controller-publish-questions';
import { workerControllerRegister } from '../fn/worker/worker-controller-register';
import { WorkerControllerRegister$Params } from '../fn/worker/worker-controller-register';
import { workerControllerReportProgress } from '../fn/worker/worker-controller-report-progress';
import { WorkerControllerReportProgress$Params } from '../fn/worker/worker-controller-report-progress';
import { WorkerHeartbeatResponseDto } from '../models/worker-heartbeat-response-dto';
import { WorkerJobDto } from '../models/worker-job-dto';
import { WorkerSessionDto } from '../models/worker-session-dto';

@Injectable({ providedIn: 'root' })
export class WorkerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `workerControllerRegister()` */
  static readonly WorkerControllerRegisterPath = '/worker/register';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `workerControllerRegister()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  workerControllerRegister$Response(params: WorkerControllerRegister$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkerSessionDto>> {
    return workerControllerRegister(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `workerControllerRegister$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  workerControllerRegister(params: WorkerControllerRegister$Params, context?: HttpContext): Observable<WorkerSessionDto> {
    return this.workerControllerRegister$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkerSessionDto>): WorkerSessionDto => r.body)
    );
  }

  /** Path part for operation `workerControllerHeartbeat()` */
  static readonly WorkerControllerHeartbeatPath = '/worker/heartbeat';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `workerControllerHeartbeat()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  workerControllerHeartbeat$Response(params: WorkerControllerHeartbeat$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkerHeartbeatResponseDto>> {
    return workerControllerHeartbeat(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `workerControllerHeartbeat$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  workerControllerHeartbeat(params: WorkerControllerHeartbeat$Params, context?: HttpContext): Observable<WorkerHeartbeatResponseDto> {
    return this.workerControllerHeartbeat$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkerHeartbeatResponseDto>): WorkerHeartbeatResponseDto => r.body)
    );
  }

  /** Path part for operation `workerControllerClaim()` */
  static readonly WorkerControllerClaimPath = '/worker/claim';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `workerControllerClaim()` instead.
   *
   * This method doesn't expect any request body.
   */
  workerControllerClaim$Response(params?: WorkerControllerClaim$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkerJobDto>> {
    return workerControllerClaim(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `workerControllerClaim$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  workerControllerClaim(params?: WorkerControllerClaim$Params, context?: HttpContext): Observable<WorkerJobDto> {
    return this.workerControllerClaim$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkerJobDto>): WorkerJobDto => r.body)
    );
  }

  /** Path part for operation `workerControllerGetVideoUrl()` */
  static readonly WorkerControllerGetVideoUrlPath = '/worker/jobs/{jobUuid}/video-url';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `workerControllerGetVideoUrl()` instead.
   *
   * This method doesn't expect any request body.
   */
  workerControllerGetVideoUrl$Response(params: WorkerControllerGetVideoUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return workerControllerGetVideoUrl(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `workerControllerGetVideoUrl$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  workerControllerGetVideoUrl(params: WorkerControllerGetVideoUrl$Params, context?: HttpContext): Observable<string> {
    return this.workerControllerGetVideoUrl$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `workerControllerGetAssetUploadUrl()` */
  static readonly WorkerControllerGetAssetUploadUrlPath = '/worker/jobs/{jobUuid}/asset-upload-url';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `workerControllerGetAssetUploadUrl()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  workerControllerGetAssetUploadUrl$Response(params: WorkerControllerGetAssetUploadUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<AssetUploadUrlDto>> {
    return workerControllerGetAssetUploadUrl(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `workerControllerGetAssetUploadUrl$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  workerControllerGetAssetUploadUrl(params: WorkerControllerGetAssetUploadUrl$Params, context?: HttpContext): Observable<AssetUploadUrlDto> {
    return this.workerControllerGetAssetUploadUrl$Response(params, context).pipe(
      map((r: StrictHttpResponse<AssetUploadUrlDto>): AssetUploadUrlDto => r.body)
    );
  }

  /** Path part for operation `workerControllerPublishQuestions()` */
  static readonly WorkerControllerPublishQuestionsPath = '/worker/jobs/{jobUuid}/questions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `workerControllerPublishQuestions()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  workerControllerPublishQuestions$Response(params: WorkerControllerPublishQuestions$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return workerControllerPublishQuestions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `workerControllerPublishQuestions$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  workerControllerPublishQuestions(params: WorkerControllerPublishQuestions$Params, context?: HttpContext): Observable<void> {
    return this.workerControllerPublishQuestions$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `workerControllerGetAnswers()` */
  static readonly WorkerControllerGetAnswersPath = '/worker/jobs/{jobUuid}/answers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `workerControllerGetAnswers()` instead.
   *
   * This method doesn't expect any request body.
   */
  workerControllerGetAnswers$Response(params: WorkerControllerGetAnswers$Params, context?: HttpContext): Observable<StrictHttpResponse<JobAnswersDto>> {
    return workerControllerGetAnswers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `workerControllerGetAnswers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  workerControllerGetAnswers(params: WorkerControllerGetAnswers$Params, context?: HttpContext): Observable<JobAnswersDto> {
    return this.workerControllerGetAnswers$Response(params, context).pipe(
      map((r: StrictHttpResponse<JobAnswersDto>): JobAnswersDto => r.body)
    );
  }

  /** Path part for operation `workerControllerReportProgress()` */
  static readonly WorkerControllerReportProgressPath = '/worker/jobs/{jobUuid}/progress';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `workerControllerReportProgress()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  workerControllerReportProgress$Response(params: WorkerControllerReportProgress$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return workerControllerReportProgress(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `workerControllerReportProgress$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  workerControllerReportProgress(params: WorkerControllerReportProgress$Params, context?: HttpContext): Observable<void> {
    return this.workerControllerReportProgress$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `workerControllerPublishEvents()` */
  static readonly WorkerControllerPublishEventsPath = '/worker/jobs/{jobUuid}/events';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `workerControllerPublishEvents()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  workerControllerPublishEvents$Response(params: WorkerControllerPublishEvents$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return workerControllerPublishEvents(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `workerControllerPublishEvents$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  workerControllerPublishEvents(params: WorkerControllerPublishEvents$Params, context?: HttpContext): Observable<void> {
    return this.workerControllerPublishEvents$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `workerControllerCompleteJob()` */
  static readonly WorkerControllerCompleteJobPath = '/worker/jobs/{jobUuid}/complete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `workerControllerCompleteJob()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  workerControllerCompleteJob$Response(params: WorkerControllerCompleteJob$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return workerControllerCompleteJob(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `workerControllerCompleteJob$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  workerControllerCompleteJob(params: WorkerControllerCompleteJob$Params, context?: HttpContext): Observable<void> {
    return this.workerControllerCompleteJob$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `workerControllerFailJob()` */
  static readonly WorkerControllerFailJobPath = '/worker/jobs/{jobUuid}/fail';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `workerControllerFailJob()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  workerControllerFailJob$Response(params: WorkerControllerFailJob$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return workerControllerFailJob(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `workerControllerFailJob$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  workerControllerFailJob(params: WorkerControllerFailJob$Params, context?: HttpContext): Observable<void> {
    return this.workerControllerFailJob$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
